import { STEPS } from "../data";
import SectionHeader from "./SectionHeader";
import { useSectionTrack } from "../hooks/useSectionTrack";

export default function HowItWorks() {
  const ref = useSectionTrack("how_it_works");

  return (
    <section ref={ref} id="how" className="sec" style={{ background: "transparent" }}>
      <SectionHeader
        label="Как это работает"
        title="От «опять никуда» до «уже там» — 4 шага"
        maxWidth={580}
      />
      <div className="grid-4">
        {STEPS.map((s, i) => (
          <div
            key={s.n}
            className={`glass card-base card-pad-lg card-lift section-enter section-enter-delay-${i + 1}`}
            style={{ position: "relative", overflow: "hidden" }}
          >
            <div className="step-watermark">{s.n}</div>
            <div style={{ position: "relative" }}>
              <div className="card-title" style={{ marginBottom: 10 }}>{s.title}</div>
              <div className="card-body">{s.body}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
